import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import api from '../api';
import { Card, Form, Input, Button, FormError } from '../components/FormStyle';
import { HeavyText, LightItalicText } from '../components/Style';
import { DisplayPost } from '../components/DisplayPost';
import SignupCTA from '../components/SignupCTA';

var Tagline = styled.p`
  text-align: center;
  color: #333;
  font-size: 1.25rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  width: 100%;
`;

var AlphaNotice = styled.div`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 0.85rem;
  color: #555;
  width: 100%;
  box-sizing: border-box;
`;

var SuccessMessage = styled.div`
  background: #e8f5e9;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  color: #2e7d32;
  font-size: 0.85rem;
  margin-bottom: 1rem;
  width: 100%;
  box-sizing: border-box;
`;

var LinkRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin-top: 1rem;
  width: 100%;
`;

var ButtonLink = styled(Link)`
  display: block;
  background: white;
  border: 1px solid black;
  border-right-width: 2px;
  border-bottom-width: 2px;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  color: black;
  font-weight: 700;
  font-size: 0.8rem;
  width: 100%;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  box-sizing: border-box;
`;

var PostsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  align-items: center;
  max-width: 410px;
  margin: 2rem auto 0;
`;

var SectionLabel = styled.div`
  width: 100%;
  max-width: 410px;
  text-align: center;
  margin: 0 0 1rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  gap: 0.75rem;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #ddd;
  }
`;

function Landing() {
  var postsState = useState([]);
  var posts = postsState[0];
  var setPosts = postsState[1];

  useEffect(function () {
    document.title = 'HeavyRotation - An endless mixtape, curated by your friends';
  }, []);

  useEffect(function () {
    api
      .get('/api/posts/trending')
      .then(function (response) {
        var data = response.data;
        var postsData = data.posts || data;
        setPosts(Array.isArray(postsData) ? postsData : []);
      })
      .catch(function () {});
  }, []);

  return (
    <>
      <SignupCTA style={{ marginTop: '2rem' }} />

      {posts.length > 0 && (
        <PostsContainer>
          <SectionLabel>Trending</SectionLabel>
          {posts
            .filter(function (p) {
              return p.media;
            })
            .map(function (post) {
              return <DisplayPost post={post} key={post.id} />;
            })}
        </PostsContainer>
      )}

      <div style={{ textAlign: 'center', padding: '2rem 0 1rem' }}>
        <Link to="/privacy" style={{ color: '#999', fontSize: '0.75rem', textDecoration: 'none' }}>
          Privacy Policy
        </Link>
      </div>
    </>
  );
}

export default Landing;
